import type { TreeSpeciesOption } from '../../../../api/workshops';
import { fieldStyle } from '../../primitives';
import { Field } from '../../primitives/Field';

import { NOT_RECORDED_LABEL } from './tree-replacement-form';
import { useTreeSpeciesOptions } from './use-tree-replacements';

export function TreeSpeciesSelect({
  value,
  onChange,
  storedSpecies = null,
  error,
}: {
  value: string;
  onChange: (speciesId: string) => void;
  /** The species already saved; listed as inactive when it is no longer offered. */
  storedSpecies?: TreeSpeciesOption | null;
  error?: string;
}) {
  const { data: species = [], isLoading, isError } = useTreeSpeciesOptions(true);
  const inactive =
    storedSpecies && !isLoading && !species.some((s) => s.id === storedSpecies.id)
      ? storedSpecies
      : null;
  const hint = isError ? (
    <span style={{ fontSize: 10.5, color: 'var(--nb-warn)' }}>Couldn’t load the species list</span>
  ) : undefined;
  return (
    <Field label="Species" hint={hint} error={error}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={isLoading}
        style={fieldStyle(error ? 'error' : undefined)}
      >
        <option value="">{isLoading ? 'Loading species…' : NOT_RECORDED_LABEL}</option>
        {inactive && <option value={inactive.id}>{inactive.name} (inactive)</option>}
        {species.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </select>
    </Field>
  );
}
